/**
 * 뉴스레터 구독 이력 저장소. 두 값을 localStorage 에 둔다.
 *
 * - 구독 완료: **모든 구독 경로가 공유한다**(상세 팝업·좌 레일·랜딩 CTA 모달). 한 곳에서
 *   구독하면 상세의 자동 팝업이 다시 뜨지 않아야 하므로 같은 플래그를 세운다
 * - 조회 수: 블로그 상세 모바일 팝업 전용. 1·4·7... 번째 조회에서만 팝업이 뜬다
 *
 * 브라우저 저장소는 시크릿 모드·용량 초과에서 던질 수 있어 모든 접근을 감싼다.
 * 실패 시엔 "노출하지 않음" 쪽으로 기울여 사용자를 성가시게 하지 않는다.
 */

const VIEW_COUNT_KEY = 'blog_newsletter_popup_view_count';
const SUBSCRIBED_KEY = 'blog_newsletter_popup_subscribed';

/** 몇 개 글마다 다시 노출할지 — 1번째, 4번째, 7번째... */
const SHOW_EVERY = 3;

export const markNewsletterSubscribed = () => {
  try {
    localStorage.setItem(SUBSCRIBED_KEY, 'true');
  } catch {
    // 저장 실패는 팝업이 다시 뜰 뿐이라 무시한다
  }
};

const hasSubscribed = (): boolean => {
  try {
    return localStorage.getItem(SUBSCRIBED_KEY) === 'true';
  } catch {
    return true;
  }
};

/**
 * 이번 조회를 카운트에 반영하고, 팝업을 띄울 차례인지 반환한다.
 * 글마다 한 번만 호출해야 한다(호출 자체가 카운트를 올린다).
 */
export const countViewAndCheckEligible = (): boolean => {
  if (hasSubscribed()) return false;

  try {
    const stored = Number(localStorage.getItem(VIEW_COUNT_KEY));
    // NaN·음수 같은 오염된 값은 첫 조회로 취급한다
    const previous = Number.isInteger(stored) && stored > 0 ? stored : 0;
    const current = previous + 1;
    localStorage.setItem(VIEW_COUNT_KEY, String(current));

    return (current - 1) % SHOW_EVERY === 0;
  } catch {
    return false;
  }
};
